import React from 'react';
import PropTypes from 'prop-types';

const Refresh = ({ color = '#8C949C' }) => (
    <svg
        width="10px"
        height="10px"
        viewBox="0 0 10 10"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            id="Svg-Icons/10px-(All-icons)/no-scale/reset"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <path
                d="M5.71428571,0.5 C3.34761905,0.5 1.42857143,2.515 1.42857143,5 L0,5 L1.85238095,6.945 L1.88571429,7.015 L3.80952381,5 L2.38095238,5 C2.38095238,3.065 3.87142857,1.5 5.71428571,1.5 C7.55714286,1.5 9.04761905,3.065 9.04761905,5 C9.04761905,6.935 7.55714286,8.5 5.71428571,8.5 C4.7952381,8.5 3.96190476,8.105 3.36190476,7.47 L2.68571429,8.18 C3.46190476,8.995 4.52857143,9.5 5.71428571,9.5 C8.08095238,9.5 10,7.485 10,5 C10,2.515 8.08095238,0.5 5.71428571,0.5 Z"
                id="Path"
                fill={color}
                className="icon-color"
            />
        </g>
    </svg>
);

Refresh.propTypes = {
    color: PropTypes.string,
};

export default Refresh;
